var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"legal",attrs:{"id":"legales"}},[_c('h2',[_vm._v("LEGALES")]),_c('div',_vm._l((_vm.legalTexts),function(item,index){return _c('CardFactors',{key:index,attrs:{"title":item.subtitle,"src":item.imgPath,"customClass":"cardFactors--align-start"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }